const dynamicParameterFields = {
  required: "Este campo é obrigatório",
  notSupportedField: "Este tipo de campo não é suportado",
  parametersNotNecessary: "Parâmetros não são necessários para este agente",
  autoFilled: "Preenchido da Integração",
  autoFilledFromIntegration: "Campo preenchido automaticamente a partir da integração selecionada"
};

export default dynamicParameterFields;